import axios from "axios";
import authHeader from "./auth-header";
const { DateTime } = require("luxon");

// const API_URL = "https://hexeverestfunctions-test.azurewebsites.net/api/";
const API_URL = "https://hexeverestfunctions.azurewebsites.net/api/";
// const API_URL = "http://localhost:7071/api/";

class ReportService {
  GetMyEmployee() {
    return axios.get(API_URL + "GetMyEmployee", { headers: authHeader() });
  }

  GetRawAccessDataByTimeRange(startDate, endDate) {
    var luxonStartDate = DateTime.fromJSDate(startDate);
    var luxonEndDate = DateTime.fromJSDate(endDate);
    var start = luxonStartDate.toISO().split("+")[0];
    var end = luxonEndDate.toISO().split("+")[0];
    return axios.get(
      API_URL +
        "GetRawAccessDataByTimeRange?startDate=" +
        start +
        "&endDate=" +
        end,
      { headers: authHeader() },
    );
  }

  GetEarliestPedestrianExitByEmployeeIdAndDate(date, employeeId) {
    console.log("hic");
    console.log(date);
    console.log(employeeId);
    var luxonStartDate = DateTime.fromJSDate(date);
    var start = luxonStartDate.toISO().split("+")[0];
    return axios.get(
      API_URL +
        "GetEarliestPedestrianExitByEmployeeIdAndDate?date=" +
        start +
        "&id=" +
        employeeId,
      { headers: authHeader() },
    );
  }

  GetLatestPedestrianEntryByEmployeeIdAndDate(date, employeeId) {
    var luxonStartDate = DateTime.fromJSDate(date);
    var start = luxonStartDate.toISO().split("+")[0];
    return axios.get(
      API_URL +
        "GetLatestPedestrianEntryByEmployeeIdAndDate?date=" +
        start +
        "&id=" +
        employeeId,
      { headers: authHeader() },
    );
  }

  GetEarliestPedestrianEntryByEmployeeIdAndDate(date, employeeId) {
    var luxonStartDate = DateTime.fromJSDate(date);
    var start = luxonStartDate.toISO().split("+")[0];
    return axios.get(
      API_URL +
        "GetEarliestPedestrianEntryByEmployeeIdAndDate?date=" +
        start +
        "&id=" +
        employeeId,
      { headers: authHeader() },
    );
  }

  GetNormalizedAccessDataByTimeRangeV3(
    startDate,
    endDate,
    employeeId,
    departmentId,
    recalculate = true,
  ) {
    var luxonStartDate = DateTime.fromJSDate(startDate);
    var luxonEndDate = DateTime.fromJSDate(endDate);
    var start = luxonStartDate.toISO().split("+")[0];
    var end = luxonEndDate.toISO().split("+")[0];
    console.log(start);
    console.log(end);
    console.log(employeeId);
    return axios.get(
      API_URL +
        "GetNormalizedAccessDataByTimeRangeV3?startDate=" +
        start +
        "&endDate=" +
        end +
        "&employeeId=" +
        employeeId +
        "&departmentId=" +
        departmentId +
        "&recalculate=" +
        recalculate,
      { headers: authHeader() },
    );
  }

  GetAllDepartmentsOfMyCompanyHistorically(startDate, endDate) {
    var luxonStartDate = DateTime.fromJSDate(startDate);
    var luxonEndDate = DateTime.fromJSDate(endDate);
    var start = luxonStartDate.toISO().split("T")[0];
    var end = luxonEndDate.toISO().split("T")[0];
    console.log(start);
    console.log(end);
    return axios.get(
      API_URL +
        "GetAllDepartmentsOfMyCompanyHistorically?startDate=" +
        start +
        "&endDate=" +
        end,
      { headers: authHeader() },
    );
  }

  GetAllDepartmentsOfMyCompanyHistoricallyByMonth(month, year) {
    return axios.get(
      API_URL +
        "GetAllDepartmentsOfMyCompanyHistoricallyByMonth?month=" +
        month +
        "&year=" +
        year,
      { headers: authHeader() },
    );
  }

  GetNormalizedAccessDataByTimeRange(
    startDate,
    endDate,
    employeeId,
    departmentId,
    recalculate = true,
  ) {
    var luxonStartDate = DateTime.fromJSDate(startDate);
    var luxonEndDate = DateTime.fromJSDate(endDate);
    var start = luxonStartDate.toISO().split("+")[0];
    var end = luxonEndDate.toISO().split("+")[0];
    console.log(start);
    console.log(end);
    console.log(employeeId);
    return axios.get(
      API_URL +
        "GetNormalizedAccessDataByTimeRangeOptimized?startDate=" +
        start +
        "&endDate=" +
        end +
        "&employeeId=" +
        employeeId +
        "&departmentId=" +
        departmentId +
        "&recalculate=" +
        recalculate,
      { headers: authHeader() },
    );
  }

  GetDailyLogsByDepartmentIdAndDay(departmentId, startDate, endDate) {
    var luxonStartDate = DateTime.fromJSDate(startDate);
    var luxonEndDate = DateTime.fromJSDate(endDate);
    var start = luxonStartDate.toISO().split("+")[0];
    var end = luxonEndDate.toISO().split("+")[0];
    console.log(end);
    return axios.get(
      API_URL +
        "GetDailyLogsByDepartmentIdAndDay?date=" +
        start +
        "&departmentId=" +
        departmentId,
      { headers: authHeader() },
    );
  }

  GetDailyLogsByDate(startDate, endDate) {
    var luxonStartDate = DateTime.fromJSDate(startDate);
    var luxonEndDate = DateTime.fromJSDate(endDate);
    var start = luxonStartDate.toISO().split("+")[0];
    var end = luxonEndDate.toISO().split("+")[0];

    return axios.get(
      API_URL + "GetDailyLogsByDate?startDate=" + start + "&endDate=" + end,
      { headers: authHeader() },
    );
  }

  GetMonthlyPresenceReviewByEmployeeIdAndMonth(employeeId, month, year) {
    return axios.get(
      API_URL +
        "GetMonthlyPresenceReviewByEmployeeIdAndMonth?employeeId=" +
        employeeId +
        "&month=" +
        month +
        "&year=" +
        year,
      { headers: authHeader() },
    );
  }

  GetYearlyStatusByDepartmentAndYear(departmentId, year) {
    return axios.get(
      API_URL +
        "GetYearlyStatusByDepartmentAndYear?id=" +
        departmentId +
        "&year=" +
        year,
      { headers: authHeader() },
    );
  }

  GetEmployeeAbsenceStatusesByEmployeeIdAndYear(employeeId, year) {
    return axios.get(
      API_URL +
        "GetEmployeeAbsenceStatusesByEmployeeIdAndYear?employeeId=" +
        employeeId +
        "&year=" +
        year,
      { headers: authHeader() },
    );
  }

  GetDailyLogsByEmployeeIdAndYear(employeeId, year) {
    return axios.get(
      API_URL +
        "GetDailyLogsByEmployeeIdAndYear?employeeId=" +
        employeeId +
        "&year=" +
        year,
      { headers: authHeader() },
    );
  }

  GetDailyLogsByDepartmentIdAndMonth(departmentId, month, year) {
    return axios.get(
      API_URL +
        "GetDailyLogsByDepartmentIdAndMonth?departmentId=" +
        departmentId +
        "&month=" +
        month +
        "&year=" +
        year,
      { headers: authHeader() },
    );
  }

  GetTotalTimeDataByDepartmentIdAndMonth(departmentId, month, year) {
    return axios.get(
      API_URL +
        "GetTotalTimeDataByDepartmentIdAndMonth?departmentId=" +
        departmentId +
        "&month=" +
        month +
        "&year=" +
        year,
      { headers: authHeader() },
    );
  }

  // GetDepartmentHistoricalDataByMonthAndYear(departmentId, month, year) {
  //   return axios.get(
  //     API_URL +
  //       "GetDepartmentHistoricalDataByMonthAndYear?id=" +
  //       departmentId +
  //       "&month=" +
  //       month +
  //       "&year=" +
  //       year,
  //     { headers: authHeader() }
  //   );
  // }

  GetStatuses() {
    return axios.get(API_URL + "GetStatuses", { headers: authHeader() });
  }

  GetEmployeesWithAbsenceStatusByDate() {
    return axios.get(API_URL + "GetEmployeesWithAbsenceStatusByDate", {
      headers: authHeader(),
    });
  }

  GetEmployeesWithAbsenceStatusByMonthAndYear(month, year) {
    return axios.get(
      API_URL +
        "GetEmployeesWithAbsenceStatusByMonthAndYear?month=" +
        month +
        "&year=" +
        year,
      {
        headers: authHeader(),
      },
    );
  }

  GetAbsentEmployeesByDate(startDate, endDate) {
    var luxonStartDate = DateTime.fromJSDate(startDate);
    var luxonEndDate = DateTime.fromJSDate(endDate);
    var start = luxonStartDate.toISO().split("+")[0];
    var end = luxonEndDate.toISO().split("+")[0];

    return axios.get(
      API_URL +
        "GetAbsentEmployeesByDate?startDate=" +
        start +
        "&endDate=" +
        end,
      {
        headers: authHeader(),
      },
    );
  }

  GetAbsentEmployeesByDateExceptStadionLogistika(startDate, endDate) {
    var luxonStartDate = DateTime.fromJSDate(startDate);
    var luxonEndDate = DateTime.fromJSDate(endDate);
    var start = luxonStartDate.toISO().split("+")[0];
    var end = luxonEndDate.toISO().split("+")[0];

    return axios.get(
      API_URL +
        "GetAbsentEmployeesByDateExceptStadionLogistika?startDate=" +
        start +
        "&endDate=" +
        end,
      {
        headers: authHeader(),
      },
    );
  }

  GetAbsentEmployeesByDateJustStadionLogistika(startDate, endDate) {
    var luxonStartDate = DateTime.fromJSDate(startDate);
    var luxonEndDate = DateTime.fromJSDate(endDate);
    var start = luxonStartDate.toISO().split("+")[0];
    var end = luxonEndDate.toISO().split("+")[0];

    return axios.get(
      API_URL +
        "GetAbsentEmployeesByDateJustStadionLogistika?startDate=" +
        start +
        "&endDate=" +
        end,
      {
        headers: authHeader(),
      },
    );
  }

  GetImeiListByEmployeeId(employeeId) {
    return axios.get(
      API_URL + "GetImeiListByEmployeeId?employeeId=" + employeeId,
      {
        headers: authHeader(),
      },
    );
  }

  GetGpsStopListByImeiAndStartDateAndEndDate(imei, startDate, endDate) {
    return axios.get(
      API_URL +
        "GetGpsStopListByImeiAndStartDateAndEndDate?imei=" +
        imei +
        "&startDate=" +
        startDate +
        "&endDate=" +
        endDate,
      {
        headers: authHeader(),
      },
    );
  }

  // EditDailyLogStatusIdByDateAndEmployeeId(date, employeeId, newStatusId) {
  //   var luxonStartDate = DateTime.fromJSDate(date);
  //   var start = luxonStartDate.toISO().split("+")[0];

  //   return axios.get(
  //     API_URL +
  //     "EditDailyLogsStatusIdByDateAndEmployeeId?date=" +
  //     start +
  //     "&id=" +
  //     employeeId +
  //     "&newStatusId=" +
  //     newStatusId,
  //     {
  //       headers: authHeader(),
  //     }
  //   );
  // }

  // EditDailyLogNoteByDateAndEmployeeId(date, employeeId, note) {
  //   var luxonStartDate = DateTime.fromJSDate(date);
  //   var start = luxonStartDate.toISO().split("+")[0];

  //   return axios.get(
  //     API_URL +
  //     "EditDailyLogsNoteByDateAndEmployeeId?date=" +
  //     start +
  //     "&id=" +
  //     employeeId +
  //     "&note=" +
  //     note,
  //     {
  //       headers: authHeader(),
  //     }
  //   );
  // }

  GetFreightVehicles() {
    return axios.get(API_URL + "GetFreightVehicles", { headers: authHeader() });
  }

  ToggleAccessStatusByAccessId(accessId, status) {
    return axios.get(
      API_URL +
        "ToggleAccessStatusByAccessId?id=" +
        accessId +
        "&status=" +
        status,
      {
        headers: authHeader(),
      },
    );
  }

  ToggleAccessUhfStatusByAccessId(accessId, status) {
    return axios.get(
      API_URL +
        "ToggleAccessUhfStatusByAccessId?id=" +
        accessId +
        "&status=" +
        status,
      {
        headers: authHeader(),
      },
    );
  }

  ToggleAccessCameraStatusByAccessId(accessId, status) {
    return axios.get(
      API_URL +
        "ToggleAccessCameraStatusByAccessId?id=" +
        accessId +
        "&status=" +
        status,
      {
        headers: authHeader(),
      },
    );
  }

  ToggleAccessRemoteStatusByAccessId(accessId, status) {
    return axios.get(
      API_URL +
        "ToggleAccessRemoteStatusByAccessId?id=" +
        accessId +
        "&status=" +
        status,
      {
        headers: authHeader(),
      },
    );
  }

  CreateNewAccessRemote(log) {
    return axios.post(API_URL + "CreateNewAccessRemote", log, {
      headers: authHeader(),
    });
  }

  CopyAccessLogs(copyAccessLogsObject) {
    return axios.post(API_URL + "CopyAccessLogs", copyAccessLogsObject, {
      headers: authHeader(),
    });
  }

  CreateManualCorrection(manualCorrection) {
    return axios.post(API_URL + "CreateManualCorrection", manualCorrection, {
      headers: authHeader(),
    });
  }

  GetEmployeeWorkhoursDataByDateAndDepartmentId(
    startDate,
    endDate,
    departmentId,
  ) {
    var luxonStartDate = DateTime.fromJSDate(startDate);
    var luxonEndDate = DateTime.fromJSDate(endDate);
    var start = luxonStartDate.toISO().split("+")[0];
    var end = luxonEndDate.toISO().split("+")[0];

    return axios.get(
      API_URL +
        "GetEmployeeWorkhoursDataByDateAndDepartmentId?startDate=" +
        start +
        "&endDate=" +
        end +
        "&id=" +
        departmentId,
      {
        headers: authHeader(),
      },
    );
  }

  GetPrivatePedestrianEventsByDate(startDate, endDate) {
    var luxonStartDate = DateTime.fromJSDate(startDate);
    var luxonEndDate = DateTime.fromJSDate(endDate);
    var start = luxonStartDate.toISO().split("+")[0];
    var end = luxonEndDate.toISO().split("+")[0];

    return axios.get(
      API_URL +
        "GetPrivatePedestrianEventsByDate?startDate=" +
        start +
        "&endDate=" +
        end,
      {
        headers: authHeader(),
      },
    );
  }

  GetFreightOutsideEventsByDate(startDate, endDate) {
    var luxonStartDate = DateTime.fromJSDate(startDate);
    var luxonEndDate = DateTime.fromJSDate(endDate);
    var start = luxonStartDate.toISO().split("+")[0];
    var end = luxonEndDate.toISO().split("+")[0];

    return axios.get(
      API_URL +
        "GetFreightOutsideEventsByDate?startDate=" +
        start +
        "&endDate=" +
        end,
      {
        headers: authHeader(),
      },
    );
  }

  GetFreightVehiclesReportByStartDateAndEndDate(startDate, endDate) {
    var luxonStartDate = DateTime.fromJSDate(startDate);
    var luxonEndDate = DateTime.fromJSDate(endDate);
    var start = luxonStartDate.toISO().split("T")[0];
    var end = luxonEndDate.toISO().split("T")[0];

    return axios.get(
      API_URL +
        "GetFreightVehiclesReportByStartDateAndEndDate?startDate=" +
        start +
        "&endDate=" +
        end,
      {
        headers: authHeader(),
      },
    );
  }

  GetRouteLogsForFreightVehiclesV2ByStartDateAndEndDate(startDate, endDate) {
    var luxonStartDate = DateTime.fromJSDate(startDate);
    var luxonEndDate = DateTime.fromJSDate(endDate);
    var start = luxonStartDate.toISO().split("T")[0];
    var end = luxonEndDate.toISO().split("T")[0];

    return axios.get(
      API_URL +
        "GetRouteLogsForFreightVehiclesV2ByStartDateAndEndDate?startDate=" +
        start +
        "&endDate=" +
        end,
      {
        headers: authHeader(),
      },
    );
  }

  GetRouteLogsForSimpleVehiclesV2ByStartDateAndEndDate(startDate, endDate) {
    var luxonStartDate = DateTime.fromJSDate(startDate);
    var luxonEndDate = DateTime.fromJSDate(endDate);
    var start = luxonStartDate.toISO().split("T")[0];
    var end = luxonEndDate.toISO().split("T")[0];

    return axios.get(
      API_URL +
        "GetRouteLogsForSimpleVehiclesV2ByStartDateAndEndDate?startDate=" +
        start +
        "&endDate=" +
        end,
      {
        headers: authHeader(),
      },
    );
  }

  GetGroupedRouteLogsForTimeSpan(startDate, endDate) {
    var luxonStartDate = DateTime.fromJSDate(startDate);
    var luxonEndDate = DateTime.fromJSDate(endDate);
    var start = luxonStartDate.toISO().split("T")[0];
    var end = luxonEndDate.toISO().split("T")[0];

    return axios.get(
      API_URL +
        "GetGroupedRouteLogsForTimeSpan?startDate=" +
        start +
        "&endDate=" +
        end,
      {
        headers: authHeader(),
      },
    );
  }

  EditAccessRemoteChoiceIdByAccessRemoteId(accessRemoteId, choiceId) {
    return axios.post(
      API_URL +
        "EditAccessRemoteChoiceIdByAccessRemoteId?id=" +
        accessRemoteId +
        "&choiceId=" +
        choiceId,
      null,
      {
        headers: authHeader(),
      },
    );
  }

  EditAccessUhfChoiceIdByAccessRemoteId(accessRemoteId, choiceId) {
    return axios.post(
      API_URL +
        "EditAccessUhfChoiceIdByAccessRemoteId?id=" +
        accessRemoteId +
        "&choiceId=" +
        choiceId,
      null,
      {
        headers: authHeader(),
      },
    );
  }

  EditRouteLog(routeLog) {
    return axios.put(API_URL + "EditRouteLog", routeLog, {
      headers: authHeader(),
    });
  }

  EditAccessCameraChoiceIdByAccessRemoteId(accessRemoteId, choiceId) {
    return axios.post(
      API_URL +
        "EditAccessCameraChoiceIdByAccessRemoteId?id=" +
        accessRemoteId +
        "&choiceId=" +
        choiceId,
      null,
      {
        headers: authHeader(),
      },
    );
  }

  EditAccessLogChoiceIdByEmployeeIdAndAccessTimeAndCheckpointId(
    employeeId,
    accessTime,
    checkpointId,
    choiceId,
  ) {
    return axios.get(
      API_URL +
        "EditAccessLogChoiceIdByEmployeeIdAndAccessTimeAndCheckpointId?employeeid=" +
        employeeId +
        "&accesstime=" +
        accessTime +
        "&checkpointid=" +
        checkpointId +
        "&choiceid=" +
        choiceId,
      {
        headers: authHeader(),
      },
    );
  }

  GetAccessGpsByVehicleIdAndPolygonIdAndStartDateAndEndDate(
    vehicleId,
    polygonId,
    startDate,
    endDate,
  ) {
    console.log("parametri");
    console.log(vehicleId);
    console.log(startDate);
    console.log(endDate);
    var luxonStartDate = DateTime.fromJSDate(startDate);
    var luxonEndDate = DateTime.fromJSDate(endDate);
    var start = luxonStartDate.toISO().split("T")[0];
    var end = luxonEndDate.toISO().split("T")[0];
    console.log(start);
    console.log(end);

    return axios.get(
      API_URL +
        "GetAccessGpsByVehicleIdAndPolygonIdAndStartDateAndEndDate?vehicleId=" +
        vehicleId +
        "&polygonId=" +
        polygonId +
        "&startDate=" +
        start +
        "&endDate=" +
        end,
      {
        headers: authHeader(),
      },
    );
  }

  GetGpsPolygons() {
    return axios.get(API_URL + "GetGpsPolygons", { headers: authHeader() });
  }

  GetGpsMontenegroDataByIdAndStartDateStringAndEndDateString(
    vehicleId,
    startDateString,
    endDateString,
  ) {
    console.log("parametri string:");
    console.log(startDateString);
    console.log(endDateString);
    return axios.get(
      API_URL +
        "GetGpsMontenegroDataByIdAndStartDateAndEndDate?id=" +
        vehicleId +
        "&startDate=" +
        startDateString +
        "&endDate=" +
        endDateString,
      {
        headers: authHeader(),
      },
    );
  }

  GetSatworkDataByIdAndStartDateStringAndEndDateString(
    vehicleId,
    startDateString,
    endDateString,
  ) {
    console.log("parametri string:");
    console.log(startDateString);
    console.log(endDateString);
    return axios.get(
      API_URL +
        "GetSatworkDataByIdAndStartDateAndEndDate?id=" +
        vehicleId +
        "&startDate=" +
        startDateString +
        "&endDate=" +
        endDateString,
      {
        headers: authHeader(),
      },
    );
  }

  GetGpsMontenegroDataByIdAndStartDateAndEndDate(
    vehicleId,
    startDate,
    endDate,
  ) {
    console.log("parametri");
    console.log(vehicleId);
    console.log(startDate);
    console.log(endDate);
    var luxonStartDate = DateTime.fromJSDate(startDate);
    var luxonEndDate = DateTime.fromJSDate(endDate);
    console.log(luxonStartDate.toISO());
    var start = luxonStartDate.toISO().split(".")[0];
    var end = luxonEndDate.toISO().split(".")[0];
    console.log(start);
    console.log(end);

    return axios.get(
      API_URL +
        "GetGpsMontenegroDataByIdAndStartDateAndEndDate?id=" +
        vehicleId +
        "&startDate=" +
        start +
        "&endDate=" +
        end,
      {
        headers: authHeader(),
      },
    );
  }

  GetSatworkDataByIdAndStartDateAndEndDate(vehicleId, startDate, endDate) {
    console.log("parametri");
    console.log(vehicleId);
    console.log(startDate);
    console.log(endDate);
    var luxonStartDate = DateTime.fromJSDate(startDate);
    var luxonEndDate = DateTime.fromJSDate(endDate);
    console.log(luxonStartDate.toISO());
    var start = luxonStartDate.toISO().split(".")[0];
    var end = luxonEndDate.toISO().split(".")[0];
    console.log(start);
    console.log(end);

    return axios.get(
      API_URL +
        "GetSatworkDataByIdAndStartDateAndEndDate?id=" +
        vehicleId +
        "&startDate=" +
        start +
        "&endDate=" +
        end,
      {
        headers: authHeader(),
      },
    );
  }

  GetRouteLogsByStartDateAndEndDateAndVehicleId(vehicleId, startDate, endDate) {
    var luxonStartDate = DateTime.fromJSDate(startDate);
    var luxonEndDate = DateTime.fromJSDate(endDate);
    var start = luxonStartDate.toISO().split("T")[0];
    var end = luxonEndDate.toISO().split("T")[0];

    return axios.get(
      API_URL +
        "GetRouteLogsByStartDateAndEndDateAndVehicleId?vehicleId=" +
        vehicleId +
        "&startDate=" +
        start +
        "&endDate=" +
        end,
      { headers: authHeader() },
    );
  }

  GetRouteLogsForFreightVehiclesByStartDateAndEndDate(startDate, endDate) {
    var luxonStartDate = DateTime.fromJSDate(startDate);
    var luxonEndDate = DateTime.fromJSDate(endDate);
    var start = luxonStartDate.toISO().split("T")[0];
    var end = luxonEndDate.toISO().split("T")[0];

    return axios.get(
      API_URL +
        "GetRouteLogsForFreightVehiclesByStartDateAndEndDate?startDate=" +
        start +
        "&endDate=" +
        end,
      { headers: authHeader() },
    );
  }

  GetEmployeeByEmployeeId(id) {
    return axios.get(API_URL + "GetEmployeeByEmployeeId?id=" + id, {
      headers: authHeader(),
    });
  }

  GetDaysoffQuantityByEmployeeId(id) {
    return axios.get(API_URL + "GetDaysoffQuantityByEmployeeId?id=" + id, {
      headers: authHeader(),
    });
  }

  CreateDayoffsQuantity(body) {
    return axios.post(API_URL + "CreateDayoffsQuantity", body, {
      headers: authHeader(),
    });
  }

  EditDaysoffQuantity(body) {
    return axios.post(API_URL + "EditDaysoffQuantity", body, {
      headers: authHeader(),
    });
  }

  DeleteDayoffsQuantity(dq) {
    return axios.delete(API_URL + "DeleteDayoffsQuantity", {
      headers: authHeader(),
      data: dq,
    });
  }

  GetRewardsByEmployeeId(id) {
    return axios.get(API_URL + "GetRewardsByEmployeeId?id=" + id, {
      headers: authHeader(),
    });
  }

  CreateReward(body) {
    return axios.post(API_URL + "CreateReward", body, {
      headers: authHeader(),
    });
  }

  EditReward(body) {
    return axios.post(API_URL + "EditReward", body, {
      headers: authHeader(),
    });
  }

  DeleteReward(dq) {
    return axios.delete(API_URL + "DeleteReward", {
      headers: authHeader(),
      data: dq,
    });
  }
}

export default new ReportService();
